import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';
import {ProductCourseInfo} from "../../models/product-course-info.model";
import {ProductExamInfo} from "../../models/product-exam-info.model";
import {ProductVariantShort} from "../../../common/common-product/models/product-short.model";
import {ProductInstructionsModel} from "../../models/product-instructions.model";
import {EnvironmentService} from "../../../snatch/services";
import {Product} from "../../models/product.model";

@Component({
  selector: 'leap-delivery-and-specifications',
  templateUrl: './delivery-and-specifications.component.html',
  styleUrls: ['./delivery-and-specifications.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryAndSpecificationsComponent implements OnInit {

  @Input() level: string;
  @Input() type: string;
  @Input() accessDuration: string;
  @Input() accessDurationType: string;
  @Input() product: Product;
  @Input() examInfo: ProductExamInfo;
  @Input() courseInfo: ProductCourseInfo;
  @Input() instructions: ProductInstructionsModel;
  @Input() selectedVariant: ProductVariantShort;
  @Input() selectedDeliveryFormatKey: string;
  @Input() countryOfOrigin: string[];


  @Output('onTabSelectCB') onTabSelectCB: EventEmitter<any> = new EventEmitter<any>();

  durationValue: string;

  constructor(private environmentService: EnvironmentService) { }

  ngOnInit() {
    if(this.environmentService.isQA || this.environmentService.isPreview || this.environmentService.isProdin){
      this.setProductType()
    }
    const {duration, durationType} = this.isProductExamType ? this.examInfo : this.courseInfo;
    this.durationValue = this.getDuration(duration, durationType);
  }

  gotToContentTab() {
    this.onTabSelectCB.emit('content');
  }

  get isProductExamType() {
    return this.type && this.type === 'Exam';
  }

  get getBrandedPortal() {
    return this.environmentService.getBrandedPortalName(this.product.seller.name);
  }

  get getVouchersExplanationUrl() {
    return this.environmentService.saharaUrl + '/support?articleId=manage-and-assign-vouchers';
  }

  get getVouchersManagementUrl() {
    return this.environmentService.saharaUrl + '/support?articleId=manage-and-assign-vouchers-directly';
  }

  get getClassManagementUrl() {
    return this.environmentService.saharaUrl + '/support?articleId=scheduling-classes';
  }

  get allAboutExamsUrl() {
    return this.environmentService.saharaUrl + '/support?articleId=almost-everything-about-exams';
  }

  get getClassesUrl() {
    return this.environmentService.saharaUrl + '/classes';
  }

  private secondsToHms(d): string {
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);

    const hDisplay = h > 0 ? (h >= 1000 ? '1000h+' : h + 'h ') : '';
    const mDisplay = m > 0 ? m + 'm ' : '';
    const sDisplay = s > 0 ? s + 's' : '';

    return hDisplay ? (h >= 1000 ? hDisplay :  hDisplay + mDisplay) : mDisplay + sDisplay;
  }

  public getDuration(duration: number, type: string): string {

    let sec;
    switch (type) {
      case 'minutes':
        sec = duration * 60;
        break;
      case 'hours':
        sec = duration * 3600;
        break;
      case 'days':
        sec = duration * 3600 * 24;
        break;
      case 'weeks':
        sec = duration * 7 * 3600 * 24;
        break;
      case 'months':
        sec = duration * 30 * 3600 * 24;
        break;
    }
    return this.secondsToHms(sec);
  }
  setProductType(){
    if(this.selectedVariant && this.selectedVariant.deliveryFormatConfig && this.selectedVariant.deliveryFormatConfig.configValue){
      let deliveryFomat =  this.selectedVariant.deliveryFormatConfig.configKey;
      if(deliveryFomat === 'diagnostics'){
        this.type = 'Diagnostic';
      }else if(deliveryFomat === 'product-assessment'){
        this.type = 'Assessment';
      }else if(deliveryFomat === 'lab'){
        this.type = 'vLab';
      }
    }
  }
}
